import _ from 'lodash';
import Strategy from 'passport-custom';

export default function buildLocalhostAuth() {
  return function localhostAuth( app ) {
    // Add the remote address to the feathers params
    app.use( ( req, res, next ) => {
      req.feathers.remoteAddress = req.connection.remoteAddress;
      next();
    } );
    const verifier = async ( req, done ) => {
      const {
        body, params,
        // query, path, method, headers, cookies, session,
      } = req;
      if ( params.provider !== 'rest' ) {
        return done( new Error( `localhost auth only via REST` ) );
      }
      if ( isLocalhost( params.remoteAddress ) ) {
        return done( null, 'localhost', body );
      } else {
        return done( new Error( `Not localhost` ) );
      }
      // done( null, user, { memberId } );
    };
    app.passport.use( 'localhost', new Strategy( verifier ) );
    app.passport.options( 'localhost', { passReqToCallback : true } );
  };
}

export function isLocalhost( addr ) {
  return ( addr === '127.0.0.1' )
    || ( addr === '[::ffff:127.0.0.1]' )
    || ( addr === '::ffff:127.0.0.1' )
    || ( addr === '[::1]' )
    || ( addr === '::1' )
    || ( addr === 'localhost' )
    || addr.match( /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/u );
}
